module.exports = __webpack_public_path__ + "static/media/univers-maison.5cb65c1e.png";